import { Typography } from "antd";
import React from "react";
import { TinyDivider } from "@bindeleddet/core/components";
import { StyledCoverImage, StyledImageWrapper } from "./style";
import image from "../../assets/images/BLCover.jpg";

const { Title, Paragraph } = Typography;

const UserTerms = () => {
  return (
    <>
      <StyledImageWrapper>
        <StyledCoverImage src={image} />
      </StyledImageWrapper>
      <div style={{ padding: "5%" }}>
        <Title level={1} style={{ display: "block" }}>
          Brukevilkår
        </Title>
        <TinyDivider width="2em" />

        <Title level={3}>1. Cookies</Title>
        <Paragraph style={{ fontSize: "1.2em" }}>
          Websiden kan bruke cookies. For å sikre at du får mest mulig relevant informasjon og best mulig service når du
          besøker vårt nettsted, vil informasjon og data kunne bli samlet inn gjennom bruk av såkalte cookies. Dette
          hjelper oss (og andre tredjeparter) med å gi deg en personlig tilpasset opplevelse når du besøker Nettstedet,
          og det gir oss også muligheten til å forbedre våre tjenester og sørge for at du lett finner det du ønsker.
        </Paragraph>

        <Title level={3}>2. Registrering, brukernavn og passord</Title>
        <Paragraph style={{ fontSize: "1.2em" }}>
          Brukeren må ved registrering kun oppgi riktige opplysninger om seg selv. Gjennom å fullføre registreringen
          samtykker brukeren i at opplysningene er sanne og korrekte. Brukeren angir passord ved registrering. Brukeren
          skal oppbevare disse opplysninger på et trygt sted slik at ingen uvedkommende kan få tilgang til disse.
          Bindeleddet NTNU vil ikke ha tilgang til passordet, og vil heller aldri spørre om det. Brukernavn og passord
          kan ikke benyttes av andre enn brukeren selv, f.eks. få andre til å melde seg på arrangementer for seg. Dersom
          brukeren mistenker at brukerens brukernavn og passord benyttes av en annen skal brukeren umiddelbart bytte
          passord.
        </Paragraph>

        <Title level={3}>3. Brukerens ansvar </Title>
        <Paragraph style={{ fontSize: "1.2em" }}>
          Brukeren har ansvar for de handlinger den utfører når websiden og tjenestene benyttes. Brukeren påtar seg å
          holde Bindeleddet NTNU fri for krav fra tredjepart som konsekvens av bruk av websiden og Bindeleddet NTNUs
          tjenester i strid med brukervilkårene.
        </Paragraph>

        <Title level={3}>4. Oppmøte og oppførsel ved arrangementer</Title>
        <Paragraph style={{ fontSize: "1.2em" }}>
          Ved et lukket arrangement vil det ikke være anledning til å gå inn i arrangementlokalet senere enn oppsatt
          starttid. Med et lukket arrangement menes ethvert arrangement som krever påmelding på Bindeleddet NTNUs
          nettsider. Deltakerne skal møte opp til oppsatt starttid og på stedet som er spesifisert på arrangementssiden.
          Dersom dette ikke overholdes, vil det automatisk registreres som «ikke oppmøtt», og man vil få en prikk som
          advarsel. Prikken vil forbli på brukerprofilen i 100 dager, og forsvinne etter dette. Dersom man får to
          prikker, vil man bli utestengt de neste 10 arrangementsdagene, det vil si dager hvor Bindeleddet NTNU har
          arrangement. Etter en slik utestengelsesperiode vil alle prikker forsvinne.
          <br />
          <br />
          Bindeleddet NTNU forbeholder seg videre retten til å gi inntil to prikker eller nekte personer adgang til
          Bindeleddets arrangementer på bakgrunn av følgende:
          <ul>
            <li>Bruk av mobiltelefon under presentasjoner</li>
            <li>Bruk av andres brukerprofil til å melde seg på og få tilgang til arrangementer</li>
            <li>Upassende eller sjenerende oppførsel</li>
            <li>Brudd på anvisninger fra Bindeleddets eller bedriftens representanter</li>
          </ul>
        </Paragraph>

        <Title level={3}>5. Immaterielle rettigheter</Title>
        <Paragraph style={{ fontSize: "1.2em" }}>
          Alt innhold på websiden beskyttes av norsk lov og internasjonal immateriell lov. All opphavsrett og andre
          immaterielle rettigheter relatert til tjenestene og websiden innehas eller lisensieres av Bindeleddet NTNU.
          Brukeren er ansvarlig for at verken brukeren selv, eller annen med brukerens brukernavn og passord, benytter
          websiden eller tjenestene til annet bruk i strid med opphavsrettslig eller annen lovstridig virksomhet i strid
          med disse brukervilkår. Brudd mot dette inkluderer (dersom dette ikke spesifikt er uttrykt tillatt) blant
          annet nedlastning av innehold, kopiering, distribusjon av innhold, tilgjengeliggjøring av innhold på annet vis
          eller offentlig visning av innhold. Brudd mot denne bestemmelsen kan være straffbart samt medføre
          erstatningsansvar for brukeren.
        </Paragraph>

        <Title level={3}>6. Ansvarsbegrensning</Title>
        <Paragraph style={{ fontSize: "1.2em" }}>
          Bindeleddet NTNU gir ingen garantier for innhold, informasjon, tjenester m.m. som tilbys gjennom websiden
          eller tjenestene. Bindeleddet NTNU gir heller ingen garantier hva gjelder funksjon, tilgjengelighet, kvalitet,
          brukervennlighet eller sikkerhet ved tjenestene eller websiden.
        </Paragraph>

        <Title level={3}>7. Lenker</Title>
        <Paragraph style={{ fontSize: "1.2em" }}>
          Websiden inneholder lenker til andre websider. Disse websidene kontrolleres ikke av Bindeleddet NTNU og er
          ikke ansvarlig for innhold og funksjoner hos slike websider.
        </Paragraph>

        <Title level={3}>8. Sikkerhet</Title>
        <Paragraph style={{ fontSize: "1.2em" }}>
          Brukeren skal ikke forsøke å omgå nettstedets sikkerhetssystem, eksempelvis gjennom å benytte andre brukeres
          brukernavn og passord eller distribuere eget brukernavn og passord til andre eller prøve å teste websidens
          sikkerhet. Brukeren skal ikke benytte websiden eller tjenestene på noen måte som kan skade, sette ut av
          funksjon, overbelaste eller forringe websiden eller andre brukeres tilgang til tjenestene eller websiden.
          Brukeren skal ikke prøve å skaffe seg ulovlig tilgang til noe datasystem, nettverk, innhold eller informasjon
          som omfattes av websiden eller system som utgjør tjenesten. Brukeren skal heller ikke forsøke å få tilgang til
          materiale eller informasjon som ikke er gjort tilgjengelig eller tilbys via websiden. Brukeren kan ikke
          benytte seg av programmer eller andre automatiserte metoder for å få tilgangs til websidens tjenester. Brudd
          på denne bestemmelsen kan være straffbart samt medføre erstatningsansvar for brukeren.
        </Paragraph>

        <Title level={3}>9. Endringer i brukervilkår</Title>
        <Paragraph style={{ fontSize: "1.2em" }}>
          Bindeleddet NTNU kan til enhver tid endre brukervilkårene ved å publisere en revidert versjon på denne siden.
          Dersom den reviderte versjonen inneholder betydelige endringer, vil du bli bedt om nytt samtykke før du kan
          fortsette å bruke Bindeleddets tjenester.
        </Paragraph>

        <Title level={3}>10. Brudd på vilkår</Title>
        <Paragraph style={{ fontSize: "1.2em" }}>
          Brudd på disse vilkår kan være straffbare og medføre erstatningsansvar for brukeren. All aktivitet på
          nettstedet loggføres. Bindeleddet NTNU kan når som helst utestenge brukere fra nettstedet og Bindeleddet NTNUs
          arrangementer på en viss tid eller permanent.
        </Paragraph>
      </div>
    </>
  );
};

export default UserTerms;
